import React, { MouseEvent } from "react";
import uuid from "uuid";
import MuiTableRow from "@material-ui/core/TableRow/TableRow";
import MuiTableCell from "@material-ui/core/TableCell/TableCell";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import TableCell from "./TableCell";
import { TableColumn } from "./types";

type Props = {
  id: string;
  data: any;
  columns: TableColumn[];
  selectable: boolean;
  isSelected: boolean;
  onSelectRow: (id: string) => void;
  onOpenDetail: (event: MouseEvent<HTMLElement>, id: string) => void;
};

const TableRow = ({
  id,
  data,
  columns,
  selectable,
  isSelected,
  onSelectRow,
  onOpenDetail
}: Props) => {
  return (
    <MuiTableRow
      hover
      aria-checked={isSelected}
      role="checkbox"
      onClick={
        selectable ? event => onSelectRow(id) : event => onOpenDetail(event, id)
      }
      tabIndex={-1}
      selected={isSelected}
    >
      {selectable && (
        <MuiTableCell padding="checkbox">
          <Checkbox
            checked={isSelected}
            inputProps={{
              "aria-label": "Select row"
            }}
          />
        </MuiTableCell>
      )}
      {columns.map(column => {
        const columnData = data[column.id];
        if (column.children) {
          return column.children.map((child, index) => {
            const nestedData = columnData[child.id];
            return (
              <TableCell
                key={uuid()}
                data={nestedData}
                row={data}
                column={child}
                firstGroupItem={index === 0}
                lastGroupItem={
                  column.children && index === column.children.length - 1
                }
              />
            );
          });
        }
        return (
          <TableCell
            key={uuid()}
            data={columnData}
            row={data}
            column={column}
          />
        );
      })}
    </MuiTableRow>
  );
};

export default TableRow;
